import { HttpInterceptorFn } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { getWebAppRequestHeaders } from '../security/app-request-metadata';

const isPaltaApiRequest = (requestUrl: string): boolean => {
  try {
    const baseHref = typeof location === 'undefined' ? environment.apiUrl : location.origin;
    const request = new URL(requestUrl, baseHref);
    const api = new URL(environment.apiUrl, baseHref);
    const apiPath = api.pathname.endsWith('/') ? api.pathname : `${api.pathname}/`;
    const requestPath = request.pathname.endsWith('/')
      ? request.pathname
      : `${request.pathname}/`;

    return request.origin === api.origin && requestPath.startsWith(apiPath);
  } catch {
    return false;
  }
};

/** Agrega identidad de aplicación únicamente a requests dirigidos a la API de Palta. */
export const appRequestMetadataInterceptor: HttpInterceptorFn = (req, next) => {
  if (!isPaltaApiRequest(req.url)) {
    return next(req);
  }

  return next(
    req.clone({
      setHeaders: getWebAppRequestHeaders(),
    }),
  );
};
